<template>
  <div class="external-iframe-overlay" v-if="visible">
    <div class="external-iframe-container">
      <div class="iframe-header">
        <h3>外部页面预览</h3>
        <button class="close-btn" @click="handleClose">×</button>
      </div>
      <iframe
        :src="url"
        frameborder="0"
        class="external-iframe"
        @load="handleLoad"
        @error="handleError"
      ></iframe>
      <div v-if="loading" class="loading-overlay">
        <div class="loading-content">
          <el-loading-spinner></el-loading-spinner>
          <p>正在加载外部页面...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExternalIframe',
  props: {
    url: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true
    }
  },
  methods: {
    handleLoad () {
      this.loading = false
    },
    handleError () {
      this.loading = false
      // 这里使用项目中已有的消息提示组件
      if (this.$message) {
        this.$message.error('页面加载失败')
      } else {
        alert('页面加载失败')
      }
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.external-iframe-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}

.external-iframe-container {
  width: 100%;
  height: 100%;
  max-width: 1200px;
  max-height: 800px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.iframe-header {
  background-color: #f5f7fa;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}

.iframe-header h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #909399;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.3s;
}

.close-btn:hover {
  background-color: #ecf5ff;
  color: #409eff;
}

.external-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-content {
  text-align: center;
  color: #3498db;
}
</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/Externallframe.vue